import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function Sweep({
  className,
  steepness = 50,
  position = 0,
  depth = 0,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  // Position 0 = left elevated, position 100 = right elevated
  const maxElevation = (steepness / 100) * 120;
  const leftY = 120 - maxElevation * (1 - position / 100);
  const rightY = 120 - maxElevation * (position / 100);

  // Control point X shifts based on position (toward the elevated side)
  const controlX = 400 + (position / 100) * 400;

  // Depth controls curve direction: 0 = concave, 100 = convex
  const midY = (leftY + rightY) / 2;
  const curveOffset = 60;
  const controlY = midY + curveOffset - (depth / 100) * curveOffset * 2;

  return (
    <svg
      className={ className }
      style={ style }
      viewBox='0 0 1200 120'
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <path
        d={ `M0,${leftY} Q${controlX},${controlY} 1200,${rightY} L1200,120 L0,120 Z` }
        fill={ fill }
        mask={ mask }
      />
    </svg>
  );
}

Sweep.propTypes = {
  className: PropTypes.string,
  steepness: PropTypes.number,
  position: PropTypes.number,
  depth: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
